export default "__VITE_ASSET__nFdpUtVW__"